var exports = {
  "k": "xae11d333--8baeb4--container",
  "v": "xae11d333--8baeb4--clickable",
};

module.exports = exports;
